import React from "react";
import "./polyfills";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import "./pages/App.css";
import { THEME_KEY, applyTheme } from "./theme";
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
const root = ReactDOM.createRoot(document.getElementById("root"));

const savedTheme = localStorage.getItem(THEME_KEY) || "auto";
applyTheme(savedTheme);

setInterval(() => {
  const currentMode = localStorage.getItem(THEME_KEY) || "auto";
  if (currentMode === "auto") {
    applyTheme("auto");
  }
}, 60 * 1000);

root.render(
  <>
    <App />
    <Analytics />
    <SpeedInsights />
  </>
);
/*
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
*/